import { z } from 'zod';
// ─── Common condition-operator vocabulary (CTSK-442) ─────────────────────
//
// Extracted from FileWorkflowConditionOperatorSchema (CTSK-437) so BOTH
// condition engines — file-workflows and tagging-rules — speak the same
// 14-operator vocabulary with the same semantics:
//
//   - positive operators use ANY-semantics (some resolved value satisfies)
//   - each negated pair is the STRICT BOOLEAN NEGATION of its positive
//     twin, i.e. a universal quantifier (`not_starts_with 'source/'`
//     means NO value starts with 'source/')
//
// The predicate implementations live in `../lib/condition-predicates.ts`
// (also shared by both engines). Keep enum + predicate table in lockstep:
// adding an operator here without a predicate arm is a compile error via
// the exhaustiveness check in applyOperator.
//
// Backward-compat aliases: file-workflow re-exports this as
// `FileWorkflowConditionOperatorSchema`; tagging-rule re-exports it as
// `RuleOperatorSchema` (a strict superset of its pre-CTSK-442 9-operator
// enum — every previously valid rule still validates).
export const CommonConditionOperatorSchema = z.enum([
    'contains', 'not_contains',
    'equals', 'not_equals',
    'starts_with', 'not_starts_with',
    'ends_with', 'not_ends_with',
    'regex_match', 'not_regex_match',
    'is_empty', 'is_not_empty',
    'before', 'after',
]);
//# sourceMappingURL=common-condition-operators.js.map